import { Type } from "@google/genai";

export const SCRIPT_DOCUMENT_SCHEMA = {
  type: Type.OBJECT,
  properties: {
    document_summary: { type: Type.STRING, nullable: true },
    uncertainties: { type: Type.ARRAY, items: { type: Type.STRING } },
    script_data: {
      type: Type.OBJECT,
      nullable: true,
      properties: {
        series_title: { type: Type.STRING, nullable: true },
        episode_number: { type: Type.STRING, nullable: true },
        episode_title: { type: Type.STRING, nullable: true },
        script_draft: { type: Type.STRING, nullable: true },
        revision_date: { type: Type.STRING, nullable: true },
        writer: { type: Type.STRING, nullable: true },
        total_pages: { type: Type.NUMBER, nullable: true },
        scene_count: { type: Type.NUMBER, nullable: true },
        characters: { type: Type.ARRAY, items: { type: Type.STRING } },
        locations: { type: Type.ARRAY, items: { type: Type.STRING } },
        scene_headings: { type: Type.ARRAY, items: { type: Type.STRING } },
        characters_by_scene: { type: Type.ARRAY, items: { type: Type.STRING } },
        scene_analysis: { type: Type.ARRAY, items: { type: Type.STRING } },
        script_summary: { type: Type.STRING, nullable: true },
        scenes: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              scene_number: { type: Type.STRING, nullable: true },
              heading: { type: Type.STRING, nullable: true },
              script_text: { type: Type.STRING, nullable: true },
              description: { type: Type.STRING, nullable: true },
              location_name: { type: Type.STRING, nullable: true },
              int_ext: { type: Type.STRING, nullable: true },
              day_night: { type: Type.STRING, nullable: true },
              script_page_range: { type: Type.STRING, nullable: true },
              characters: { type: Type.ARRAY, items: { type: Type.STRING } },
              inferred_vfx_requirements: { type: Type.ARRAY, items: { type: Type.STRING } },
              estimated_complexity: { type: Type.STRING, nullable: true }
            }
          }
        }
      }
    }
  }
};
